<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :header="null"
    @cancel="closeModal"
    width="70rem"
    wrapClassName="act-now-letter-modal"
  >
    <div class="act-now-letter-modal-container">
      <div class="act-now-letter-modal-container__header">
        <h1 class="act-now-letter-modal-container__header--title">
          Letter
        </h1>
      </div>
      <div class="act-now-letter-modal-container__body">
        <div class="act-now-letter-modal-container__body--chat-wrapper">
          <div
            class="act-now-letter-modal-container__body--chat-wrapper--header"
            v-if="!shareActNowLetterLoading"
          >
            <button
              class="act-now-letter-modal-container__body--chat-wrapper--header--copied-btn"
              @click="copyLetter"
            >
              <img src="@/assets/icons/copy-icon.png" alt="Copy" />
              {{ copied ? "Copied!" : "Copy" }}
            </button>
          </div>
          <template v-if="shareActNowLetterLoading">
            <a-skeleton 
              class="act-now-letter-modal-container__body--chat-wrapper--letter-skeleton"
              active 
              :title="null" 
              :paragraph="{
                rows: 6,
                width: ['100%', '100%', '100%', '100%', '80%', '70%', '60%'],
              }"
            />
          </template>
          <template v-else>
            <div
              class="act-now-letter-modal-container__body--chat-wrapper--letter"
              ref="letterContent"
            >
              <p v-html="parseMessage(sharedActNowLetter)" />
            </div>
            <h1
              class="act-now-letter-modal-container__body--chat-wrapper--ai-meesage"
            >
              Note: AI-generated content — please verify for accuracy.
            </h1>
            <div
              v-if="sharedActNowLetterArticleLink"
              class="act-now-letter-modal-container__body--chat-wrapper--article-link"
            >
              <a :href="sharedActNowLetterArticleLink" @click.stop="closeModal()" class="link">
                {{ sharedActNowLetterArticleLink }}
              </a>
              <button class="copy-btn" @click="copyLink">
                <img src="@/assets/icons/copy-icon.png" alt="Copy" />
                <div class="copied" v-if="copiedLink">
                  <p>Copied!</p>
                </div>
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import { mapActions } from 'vuex';
import { marked } from 'marked'
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      copied: false,
      copiedLink: false,
    };
  },
  computed:{
    ...mapGetters({
      sharedActNowLetter: 'discover/sharedActNowLetter',
      shareActNowLetterLoading: 'discover/shareActNowLetterLoading',
      sharedActNowLetterArticleLink: 'discover/sharedActNowLetterArticleLink'
    }) ,
  },
  watch:{
    visible:{
      handler(val){
        if (val){
          (async()=>{
            await this.openSharedLetter()
          })();
        }
      }, immediate:true
    }
  },
  methods: {
    ...mapActions({
      openSharedLetter: 'discover/openSharedLetter'
    }),
    closeModal() {
      this.$emit("handle-close", false);
    },
    copyLetter() {
      const letterElement = this.$refs.letterContent;
      if (letterElement) {
        const text = letterElement.innerText;
        navigator.clipboard.writeText(text).then(() => {
          this.copied = true;
          setTimeout(() => {
            this.copied = false;
          }, 1000);
        });
      }
    },
    copyLink() {
      navigator.clipboard.writeText(this.sharedActNowLetterArticleLink).then(() => {
        this.copiedLink = true;
        setTimeout(() => {
          this.copiedLink = false;
        }, 1000);
      });
    },
    parseMessage(letterObject){
        if (letterObject?.letter || letterObject?.content){
          return marked.parse(letterObject?.letter || letterObject?.content)
        }
        else{
          return ''
        }
    },
  },
};
</script>

<style lang="scss">
.act-now-letter-modal {
  .ant-modal {
    top: 8rem;
    padding-bottom: 0;
    .ant-modal-content {
      padding: 0;
      background-color: $color-white;

      .ant-modal-close {
        margin: 2rem 2rem 0 0;
        .ant-modal-close-x {
          .anticon {
            font-size: 2rem;
            @include respond(phone-large) {
              font-size: 3rem;
            }
          }
        }
      }

      .ant-modal-body {
        .act-now-letter-modal-container {
          padding-bottom: 2.5rem;
          &__header {
            padding: 2.5rem 2.5rem 1rem;
            display: flex;
            align-items: center;
            gap: 1rem;
            &--title {
              font-size: 2.5rem;
              font-family: $font-primary-bold;
              color: $color-black;
              margin-bottom: 0;
              line-height: normal;
              @include respond(phone-large) {
                font-size: 3.2rem;
              }
            }
          }
          &__body {
            padding: 0 2.5rem 1.5rem;
            max-height: calc(100vh - 24rem);
            overflow-y: auto;
            overflow-x: hidden;
            @include respond(phone-large) {
              max-height: calc(100vh - 45rem);
            }
            &--chat-wrapper {
              margin-bottom: 1rem;
              &--header {
                background-color: $color-white;
                width: 100%;
                position: sticky;
                top: 0;
                padding-bottom: 0.5rem;
                @include respond(phone-large) {
                  top: -0.2rem;
                }
                &--copied-btn {
                  display: flex;
                  align-items: center;
                  background-color: #e7e7e7;
                  padding: 0.4rem 0.6rem;
                  border: none;
                  outline: none;
                  font-size: 1.4rem;
                  line-height: normal;
                  font-family: $font-primary-medium;
                  cursor: pointer;
                  gap: 0.5rem;
                  margin-left: auto;
                  img {
                    width: 1.5rem;
                    height: auto;
                  }
                  @include respond(phone-large) {
                    font-size: 1.8rem;
                    padding: 0.8rem 1rem;
                    img {
                      width: 1.7rem;
                    }
                  }
                }
              }
              &--letter-skeleton {
                margin: 3rem 0 0;
                .ant-skeleton-content {
                  .ant-skeleton-paragraph {
                    margin: 0;
                    li {
                      margin-bottom: 1.5rem;
                      margin-top: 0;
                      height: 2rem;
                    }
                  }
                }
              }
              &--letter {
                font-size: 1.6rem;
                font-family: $font-primary;
                color: $color-black;
                margin-bottom: 0;
                line-height: 2.2rem;
                @include respond(phone-large) {
                  font-size: 2.2rem;
                  line-height: 3.3rem;
                }
                p,
                h1,
                h2,
                h3,
                h4,
                h5,
                h6,
                a,
                li {
                  font-size: inherit;
                  line-height: inherit;
                  margin-bottom: 0.8rem;
                }
                hr {
                  display: block;
                  margin-bottom: 0.8rem;
                }
                ul,
                ol {
                  padding-left: 2.5rem;
                }
                a {
                  color: $color-links;
                  cursor: pointer;
                }
              }
              &--ai-meesage {
                font-style: italic;
                font-size: 1.6rem;
                font-family: $font-primary-medium;
                line-height: normal;
                margin: 1.5rem 0 0;
                color: $color-black;
                @include respond(phone-large) {
                  font-size: 2.2rem;
                }
              }
              &--article-link {
                margin-top: 1.5rem;
                display: flex;
                align-items: center;
                gap: 0.5rem;
                .link {
                  font-size: 1.6rem;
                  font-family: $font-primary-medium;
                  line-height: normal;
                  margin: 0;
                  color: $color-links;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: calc(100% - 3rem);
                  margin-top: 0.1rem;
                  display: inline-block;
                  @include respond(phone-large) {
                    font-size: 2.2rem;
                    max-width: calc(100% - 5.5rem);
                  }
                }
                .copy-btn {
                  border: none;
                  outline: none;
                  border-radius: 0.5rem;
                  width: 2.5rem;
                  height: 2.5rem;
                  background-color: #8080803d;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  position: relative;
                  img {
                    width: 1.5rem;
                    height: auto;
                  }
                  .copied {
                    position: absolute;
                    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
                    bottom: 3rem;
                    padding: 0.5rem 1rem;
                    border-radius: 0.5rem;
                    z-index: 1;
                    background-color: $color-white;
                    right: 0;
                    p {
                      font-size: 1.2rem;
                      font-family: $font-primary;
                      margin-bottom: 0;
                      line-height: normal;
                    }
                  }
                  @include respond(phone-large) {
                    width: 3.5rem;
                    height: 3.5rem;
                    img {
                      width: 1.8rem;
                    }
                    .copied {
                      bottom: 4.5rem;
                      p {
                        font-size: 1.8rem;
                      }
                    }
                  }
                }
              }
            }
            &::-webkit-scrollbar {
              width: 0.4rem;
              height: 0.4rem;
            }

            &::-webkit-scrollbar-track {
              background-color: transparent;
              border-radius: 0.8rem;
            }

            &::-webkit-scrollbar-thumb {
              background-color: $color-primary;
              border-radius: 0.8rem;
            }
          }
        }
      }
    }
  }
}
</style>
